import { render, staticRenderFns } from "./CurrPortfolioMenu.vue?vue&type=template&id=2c3ed250&"
import script from "./CurrPortfolioMenu.vue?vue&type=script&lang=js&"
export * from "./CurrPortfolioMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports